
export const useGetReductionFromPercentage = (): [(total: number, percentage: number) => number, (total: number, percentage: number) => number] => {

    const getTotalMinusReduction = (total: number, percentage: number): number => {
        return total - getReduction(total, percentage)
    }

    const getReduction = (total: number, percentage: number): number => {
        return total * (percentage / 100)
    }

    return [getTotalMinusReduction, getReduction]
}
